export default "__VITE_ASSET__KLg3zho6__"